/**
 * Context strip for a screen opened from a Marketing Morning Digest
 * button: the email's snapshot count beside the live count. Renders
 * nothing for an ordinary visit.
 */
import { EnvelopeSimple } from "@phosphor-icons/react";
import { digestOriginText } from "@/lib/digestOrigin";

export default function DigestOriginNote({ origin, current }) {
  if (!origin) return null;
  return (
    <div className="flex items-start gap-2 border border-[#BFDBFE] bg-[#EFF6FF] text-[#1E3A8A] px-3 py-2 mb-3 text-xs"
         role="note" data-testid="digest-origin-note">
      <EnvelopeSimple size={14} className="mt-0.5 shrink-0" />
      <span>{digestOriginText(origin, current)}</span>
    </div>
  );
}
